import { isNil } from 'lodash';

import deRef from 'utils/objects/deRef.util';

const deRefAt = (keyOrIndex, ref) => {
  const current = deRef(ref);
  return isNil(current) ? undefined : current[keyOrIndex];
};

// noinspection JSUnusedGlobalSymbols
export default deRefAt;
